var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"enroll-distribute-status"},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"main"},[_c('div',{staticClass:"main-cont"},[_c('EnrollDistributeStatusMain')],1)])])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"header"},[_c('div',{staticClass:"title"},[_vm._v("新生分班赋学号")])])
}]

export { render, staticRenderFns }